import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper, type ResolvedChildDefinition } from '../../../ai';

import { type CollapsibleContainerDefinition } from './collapsible-container.definition';

export class CollapsibleContainerDefinitionMapper
  implements DefinitionMapper<'collapsibleContainer'>
{
  readonly type = 'collapsibleContainer';

  assembleChildren(
    definition: PartialDeep<CollapsibleContainerDefinition>,
    slotChildren: ResolvedChildDefinition[][],
  ): void {
    const firstSlotChildren = slotChildren[0];
    if (firstSlotChildren) {
      definition.children =
        firstSlotChildren as unknown as CollapsibleContainerDefinition['children'];
    }
  }

  extract(
    element: CanvasElementFrom<'collapsibleContainer'>,
  ): PartialDeep<CollapsibleContainerDefinition> {
    const header = element.props.content?.header;

    return {
      title: header?.title,
      iconName: header?.icon,
    };
  }
}
